import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getRandomPin, getNowDateTimeSqlServerFormat } from '../helpers/Helpers.js';

export default function AziendeSellerDettagli() {

    // Costanti

    const { id } = useParams();
    const client = getWebClient();
    const navigate = useNavigate();

    const [labels, setLabels] = useState();
    const [model, setModel] = useState({ id: uuidv4(), nome: '' });
    const [deleteButton, setDeleteButton] = useState('');

    const [macroregioniField, setMacroregioniField] = useState([]);
    const [tipologieField, setTipologieField] = useState([]);
    const [dateAbilitateField, setdateAbilitateField] = useState();

    // Chiamate webAPI

    function sellerGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/aziendeseller/${id}`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function macroregioniGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/macroregioni`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function tipologieGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/tipologieAziendeSeller`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function dateGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/date`).then((response) => {
                resolve(response.data);
            });
        });
    }

    // Inizializzazione

    useEffect(() => {

        if (id === 'new') {

            setLabels({
                "title": "Creazione nuovo seller",
                "submitButtonText": "Crea il seller",
            });

            Promise.all([macroregioniGetPromise(), tipologieGetPromise(), dateGetPromise()])

                .then((results) => {

                    let macroregioniGetPromiseResult = results[0];
                    let tipologieGetPromiseResult = results[1];
                    let dateGetPromiseResult = results[2];

                    setModel({
                        id: uuidv4(),
                        token: uuidv4(),
                        pin: getRandomPin(),
                        dataRegistrazione: getNowDateTimeSqlServerFormat(),
                        idMacroregione: macroregioniGetPromiseResult[0].id,
                        idTipologia: tipologieGetPromiseResult[0].id,
                        idTabricerca: '',
                        idDateAbilitate: [],
                        abilitato: false,
                        ragioneSociale: '',
                        localita: '',
                        nazione: '',
                        email: '',
                        telefono: '',
                        referenteNome: '',
                        referenteSesso: '',
                        profilo: '',
                        sitoInternet: '',
                        numeroStand: '',
                        dataOraUltimoAggiornamento: getNowDateTimeSqlServerFormat()
                    });

                    setMacroregioniField(
                        <Field name="idMacroregione" id="idMacroregione" as="select" className="form-select">
                            {macroregioniGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.nome}</option>
                            )}
                        </Field>
                    );

                    setTipologieField(
                        <Field name="idTipologia" id="idTipologia" as="select" className="form-select">
                            {tipologieGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.nome}</option>
                            )}
                        </Field>
                    );

                    setdateAbilitateField(
                        <Field name="idDateAbilitate" id="idDateAbilitate" as="select" className="form-select dateabilitate-select" multiple={true} size={dateGetPromiseResult.length}>
                            {dateGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.dataTestuale}</option>
                            )}
                        </Field>
                    );

                })

                .catch((err) => {
                    console.log(err);
                });

        } else {

            setLabels({
                "title": "Dettagli del seller",
                "submitButtonText": "Salva le modifiche",
            });

            setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina il seller</button>);

            Promise.all([sellerGetPromise(), macroregioniGetPromise(), tipologieGetPromise(), dateGetPromise()])

                .then((results) => {

                    let sellerGetPromiseResult = results[0];
                    let macroregioniGetPromiseResult = results[1];
                    let tipologieGetPromiseResult = results[2];
                    let dateGetPromiseResult = results[3];

                    setModel(sellerGetPromiseResult);
                    debugger;
                    setMacroregioniField(
                        <Field name="idMacroregione" id="idMacroregione" as="select" className="form-select">
                            {macroregioniGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.nome}</option>
                            )}
                        </Field>
                    );

                    setTipologieField(
                        <Field name="idTipologia" id="idTipologia" as="select" className="form-select">
                            {tipologieGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.nome}</option>
                            )}
                        </Field>
                    );

                    setdateAbilitateField(
                        <Field name="idDateAbilitate" id="idDateAbilitate" as="select" className="form-select dateabilitate-select" multiple={true} size={dateGetPromiseResult.length}>
                            {dateGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.dataTestuale}</option>
                            )}
                        </Field>
                    );

                })

                .catch((err) => {
                    console.log(err);
                });

        }

    }, []);

    // Delete

    const handleDeleteStep1 = (event) => {

        setDeleteButton(
            <div className="btn-group" role="group" style={{ marginTop: 40, marginLeft: 10 }}>
                <button type="button" className="btn btn-primary" onClick={handleDeleteUndo}>Annulla</button>
                <button type="button" className="btn btn-danger" onClick={handleDeleteStep2}>Procedi con l'eliminazione</button>
            </div>
        );

    }

    const handleDeleteStep2 = (event) => {

        client.delete(`/api/aziendeseller/${id}`)
            .then(function (response) {
                navigate("/aziendeseller");
            })
            .catch(function (error) {
                alert("Si sono verificati errori durante l'operazione di eliminazione. Riprovare in un secondo momento.");
            });

    }

    const handleDeleteUndo = (event) => {

        setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina il seller</button>);

    }

    if (labels === undefined || model === undefined) { return; }

    return (
        <>

            <style
                dangerouslySetInnerHTML={{
                    __html: ".dateabilitate-select option { color:#bbbbbb; background-color: white; } option:checked { color:#000000; background-color: white; }"
                }}
            />

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>{labels.title}</h4>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>

                <Formik

                    initialValues={model}
                    enableReinitialize="true"

                    validate={values => {

                        const errors = {};

                        document.getElementById('idTabricerca').classList.remove("is-invalid");
                        document.getElementById('pin').classList.remove("is-invalid");
                        document.getElementById('ragioneSociale').classList.remove("is-invalid");

                        document.getElementById('localita').classList.remove("is-invalid");
                        document.getElementById('nazione').classList.remove("is-invalid");
                        document.getElementById('email').classList.remove("is-invalid");
                        document.getElementById('referenteNome').classList.remove("is-invalid");
                        document.getElementById('referenteSesso').classList.remove("is-invalid");

                        if (values.abilitato) {

                            if (!values.localita) {
                                errors.localita = <>Il campo Localit&agrave; &egrave; richiesto</>;
                                document.getElementById('localita').classList.add("is-invalid")
                            }

                            if (!values.nazione) {
                                errors.nazione = <>Il campo Nazione &egrave; richiesto</>;
                                document.getElementById('nazione').classList.add("is-invalid")
                            }

                            if (!values.email) {
                                errors.email = <>Il campo Email &egrave; richiesto</>;
                                document.getElementById('email').classList.add("is-invalid")
                            }

                            if (!values.referenteNome) {
                                errors.referenteNome = <>Il campo Referente nome &egrave; richiesto</>;
                                document.getElementById('referenteNome').classList.add("is-invalid")
                            }

                            if (!values.referenteSesso) {
                                errors.referenteSesso = <>Il campo Referente sesso &egrave; richiesto</>;
                                document.getElementById('referenteSesso').classList.add("is-invalid")
                            }

                        }

                        if (!values.idTabricerca) {
                            errors.idTabricerca = <>Il campo Id TabRicerca &egrave; richiesto e deve essere un numero intero</>;
                            document.getElementById('idTabricerca').classList.add("is-invalid")
                        }

                        if (!values.pin || values.pin.length < 8) {
                            errors.pin = <>Il campo Pin &egrave; richiesto e deve avere una lunghezza minima di 8 caratteri</>;
                            document.getElementById('pin').classList.add("is-invalid")
                        }

                        if (!values.ragioneSociale) {
                            errors.ragioneSociale = <>Il campo Regione sociale &egrave; richiesto</>;
                            document.getElementById('ragioneSociale').classList.add("is-invalid")
                        }

                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting }) => {

                        if (id === 'new') {

                            client.post('/api/aziendeseller', values)
                                .then(function (response) {
                                    navigate("/aziendeseller");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        } else {

                            debugger;

                            client.put('/api/aziendeseller', values)
                                .then(function (response) {
                                    navigate("/aziendeseller");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        }
                    }}
                >

                    {({ isSubmitting }) => (

                        <Form>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Id</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="id" id="id" readOnly="readonly" maxLength="36" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Id Tabricerca</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="number" name="idTabricerca" id="idTabricerca" />
                                    <ErrorMessage className="invalid-feedback" name="idTabricerca" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Macroregione</label>
                                <div className="col-sm-10">
                                    {macroregioniField}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Tipologia</label>
                                <div className="col-sm-10">
                                    {tipologieField}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Token</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="token" id="token" readOnly="readonly" maxLength="36" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Pin</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="pin" id="pin" maxLength="50" />
                                    <ErrorMessage className="invalid-feedback" name="pin" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">
                                    Date abilitate
                                    <div className="form-text">Ctrl + click per selezionare</div>
                                </label>
                                <div className="col-sm-10">
                                    {dateAbilitateField}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Abilitato</label>
                                <div className="col-sm-10">
                                    <Field className="form-check-input" type="checkbox" name="abilitato" id="abilitato" />
                                    <ErrorMessage className="invalid-feedback" name="abilitato" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Ragione sociale</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="ragioneSociale" id="ragioneSociale" maxLength="50" />
                                    <ErrorMessage className="invalid-feedback" name="ragioneSociale" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Localita</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="localita" id="localita" maxLength="100" />
                                    <ErrorMessage className="invalid-feedback" name="localita" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Nazione</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="nazione" id="nazione" maxLength="100" />
                                    <ErrorMessage className="invalid-feedback" name="nazione" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Email</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="email" name="email" id="email" maxLength="64" />
                                    <ErrorMessage className="invalid-feedback" name="email" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Telefono</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="telefono" id="telefono" maxLength="50" />
                                    <ErrorMessage className="invalid-feedback" name="telefono" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Referente nome</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="referenteNome" id="referenteNome" maxLength="50" />
                                    <ErrorMessage className="invalid-feedback" name="referenteNome" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Referente sesso</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="referenteSesso" id="referenteSesso" maxLength="1" />
                                    <ErrorMessage className="invalid-feedback" name="referenteSesso" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Profilo</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" component="textarea" rows="6" name="profilo" id="profilo" maxLength="3500" />
                                    <ErrorMessage className="invalid-feedback" name="profilo" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Data registrazione</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="dataRegistrazione" id="dataRegistrazione" readOnly="readonly" />
                                    <ErrorMessage className="invalid-feedback" name="dataRegistrazione" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Sito internet</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="sitoInternet" id="sitoInternet" maxLength="150" />
                                    <ErrorMessage className="invalid-feedback" name="sitoInternet" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Numero stand</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="numeroStand" id="numeroStand" maxLength="10" />
                                    <ErrorMessage className="invalid-feedback" name="numeroStand" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Ultimo aggiornamento</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="dataOraUltimoAggiornamento" id="dataOraUltimoAggiornamento" readOnly="readonly" />
                                    <ErrorMessage className="invalid-feedback" name="dataOraUltimoAggiornamento" component="div" />
                                </div>
                            </div>

                            <button className="btn btn-primary" style={{ marginTop: 40 }} type="submit" disabled={isSubmitting}>{labels.submitButtonText}</button>
                            {deleteButton}

                        </Form>

                    )}

                </Formik>

            </div>

        </>
    )
}
